import React from 'react';
import { ReactComponent as Pdf } from '../assets/icons/media_type/file-pdf.svg';
import { ReactComponent as Prezi } from '../assets/icons/media_type/file-prezi.svg';
import { ReactComponent as Text } from '../assets/icons/media_type/file-text.svg';
import { ReactComponent as Video } from '../assets/icons/media_type/file-video.svg';
import { ReactComponent as Image } from '../assets/icons/media_type/file-image.svg';
/*
import {ReactComponent as Audio} from '../assets/icons/media_type/file-audio.svg';
import {ReactComponent as Music} from '../assets/icons/media_type/file-music.svg';
import {ReactComponent as Doc} from '../assets/icons/media_type/file-word.svg';
*/

import PdfIcon from '../components/icons/file/Pdf';
import VideoIcon from '../components/icons/file/Video';
import PreziIcon from '../components/icons/file/Prezi';
import TextIcon from '../components/icons/file/Text';
import ImageIcon from '../components/icons/file/Image';
import { IconProps } from '@chakra-ui/react';

const getMediaTypeIcon = (media_type: string) => {
  switch (media_type) {
    case 'pdf':
      return Pdf;
    case 'youtube':
      return Video;
    case 'prezi':
      return Prezi;
    case 'file':
      return Text;
    case 'cms':
      return Image;
    case 'drive':
      return Pdf;
    case 'assessment':
      return Pdf;
    default:
      return Pdf;
  }
};

const MediaTypeIcon: React.FC<{ mediaType: string } & IconProps> = (
  allProps,
) => {
  const { mediaType, ...props } = allProps;
  switch (mediaType) {
    case 'pdf':
      return <PdfIcon {...props} />;
    case 'youtube':
      return <VideoIcon {...props} />;
    case 'prezi':
      return <PreziIcon {...props} />;
    case 'file':
      return <TextIcon {...props} />;
    case 'cms':
      return <ImageIcon {...props} />;
    case 'drive':
      return <PdfIcon {...props} />;
    case 'assessment':
      return <PdfIcon {...props} />;
    default:
      return <PdfIcon {...props} />;
  }
};

export { getMediaTypeIcon, MediaTypeIcon };
export default getMediaTypeIcon;
